module.exports = __webpack_public_path__ + "img/ricelog_pinicon_030.d2fce839.png";